export default __webpack_public_path__ + "static/media/castle-of-glass.5dabaa2c.jpg";